import React, { useEffect, useState } from "react";
import img from "./Img/Better3.webp";
import better from "./Img/Better4.jpg";

function BgBetter() {
  const [isLargeScreen, setIsLargeScreen] = useState(
    () => window.matchMedia("(min-width: 1280px)").matches,
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)");
    const handleChange = (e) => setIsLargeScreen(e.matches);
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  if (isLargeScreen) {
    return (
      <div
        className="d-flex position-relative flex-column m-0 p-0 uh-122 w-100 justify-content-end"
        style={{
          overflow: "hidden",
        }}
      >
        {/* Image */}
        <div
          className="uh-122 m-0 p-0 w-100"
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
        <div
          className="  position-absolute upx-20 uh-50 upy-20 uw-130  " // Positioned to the top-right corner of the parent div
        >
          {/* Content inside the right-side div */}
          <p className=" m-0 p-0 ufs-13 fw-bold text-gray">Better</p>
          <p className=" m-0 p-0 ufs-4 fw-bold  text-gray">
            GAMIFIED REHABILITATION DEVICE.{" "}
          </p>
          {/* <div className="m-0 d-flex upt-2 text-center uh-50">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLScJX9zGSm7uGiT1FYF1m33zA4oQi2NbBRHniRLHAUtdjifmOA/viewform?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                className="ufs-6 uw-60 uh-12 text-center text-gray-light border-0 fw-bold bg-dark-blue br-10"
                type="button"
              >
                Book my Demo
              </button>
            </a>
          </div> */}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="d-flex position-relative flex-column m-0 p-0 w-100 justify-content-end"
        style={{
          overflow: "hidden",
        }}
      >
        {/* Image */}
        <div
          className=" m-0 p-0 w-100"
          style={{
            backgroundImage: `url(${better})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "90vh",
          }}
        ></div>
        <div
          className="  position-absolute upx-20 uh-160 upy-20 w-100 bottom-0  " // Positioned to the top-right corner of the parent div
        >
          {/* Content inside the right-side div */}
          <p className=" m-0 p-0 ufs-14 fw-bold text-gray">Better</p>
          <p className=" m-0 p-0 ufs-12 fw-bold  text-gray">
            Gamified Rehabilation Device.{" "}
          </p>
          {/* <div className="m-0 d-flex upt-2 text-center uh-50">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLScJX9zGSm7uGiT1FYF1m33zA4oQi2NbBRHniRLHAUtdjifmOA/viewform?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                className="ufs-14 up-5 upx-8 text-center text-gray-light border-0 fw-bold bg-dark-blue br-20"
                type="button"
              >
                Book my Demo
              </button>
            </a>
          </div> */}
        </div>
      </div>
    );
  }
}
export default BgBetter;
